<template>
  <div class="filter-tabs contact-filter has-border-bottom">
    <div
      v-for="item in items"
      :class="['filter-item', item.id === active && 'active']"
      :key="item.id"
      @click="handleFilterClick(item.id, item.name)"
    >
      {{item.name}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tabs',
  props: {
    items: Array,
    active: String || Number
  },
  model: {
    prop: 'active',
    event: 'change'
  },
  data () {
    return {

    }
  },
  methods: {
    handleFilterClick (id, name) {
      this.$emit('change', id, name)
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.filter-tabs {
  display: flex;
  flex: 0 0 auto;
  height: 44px;
  line-height: 44px;
  background-color: #fff;

  & .filter-item {
    flex: 1 1 auto;
    text-align: center;
    color: var(--secondlyText);

    &.active {
      position: relative;
      color: var(--primaryText);

      &::after {
        display: inline-block;
        bottom: -1px;
        left: 50%;
        margin-left: -14px;
        position: absolute;
        content: ' ';
        width: 28px;
        height: 2px;
        background-color: var(--primaryColor);
      }
    }
  }
}
</style>
